import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import axios from '../../../services/api';
import { toast } from 'react-toastify';
import { generateUUID } from '../../../services/utils';
import { useTranslation } from 'react-i18next';

const CreateRoomModal = ({ isOpen, onClose, building, room, onSuccess }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    roomId: generateUUID(),
    floor: '',
    roomNumber: ''
  });

  useEffect(() => {
    if (room) {
      setFormData({
        roomId: room.roomId,
        floor: room.floor,
        roomNumber: room.roomNumber
      });
    }else{
      setFormData({
        roomId: generateUUID(),
        floor: '',
        roomNumber: ''
      });
    }
  }, [room]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (room) {
        await axios.put(`/rooms/${room._id}`, formData);
        toast.success(t('Room updated successfully'));
      } else {
        await axios.post(`/rooms`, { buildingId: building._id, ...formData });
        toast.success(t('Room created successfully'));
      }
      setFormData({
        roomId: generateUUID(),
        floor: '',
        roomNumber: ''
      });
      onSuccess();
      onClose();
    } catch (error) {
      toast.error(t('Room save error'));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-end pr-[20%] pt-[10%] z-[60] app-text">
      <div className="bg-white w-[calc(60vh*0.7)] h-[60vh] rounded-lg shadow-xl relative overflow-hidden">
        <div className="bg-black text-white px-4 py-3 rounded-t-lg flex justify-between items-center">
          <h2 className="text-lg font-semibold">{room ? t('Edit Room') : t('Create New Room')}</h2>
          <button onClick={onClose} className="text-white/70 hover:text-white transition-colors">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 h-[calc(60vh-116px)] overflow-y-auto">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">{t('Room ID')}</label>
              <input
                type="text"
                value={formData.roomId}
                onChange={(e) => setFormData({ ...formData, roomId: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">{t('Floor')}</label>
              <input
                type="number"
                value={formData.floor}
                onChange={(e) => setFormData({ ...formData, floor: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">{t('Room Number')}</label>
              <input
                type="text"
                value={formData.roomNumber}
                onChange={(e) => setFormData({ ...formData, roomNumber: e.target.value })}
                className="w-full border border-gray-300 rounded px-3 py-2"
                required
              />
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 px-4 py-3 border-t border-gray-200 bg-white">
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-1.5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
              >
                {t('Cancel')}
              </button>
              <button
                type="submit"
                className="px-4 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                {room ? t('Update') : t('Save')}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateRoomModal;